import { IEbayOffer } from "../../models/EbayOffer";
import { IPart } from "../../models/Part";
import RsCoreImage from "../core/RsCoreImage";

export function ListingStatus({ offer, part, width = "w-full" }: { offer: IEbayOffer | undefined, part: IPart, width?: string }) {
  let style = "px-4 text-xs mx-auto text-center rounded-full h-10 flex justify-center items-center";
  let colour = "bg-gray-200 text-gray-500";
  let status = "Not Published";

  if (part.soldDate) {
    colour = "bg-green-200 text-green-500";
    status = "Sold";
  }

  if (part.isCore) return (
    <RsCoreImage />
  )

  if (!offer) {
    return (
      <div className={`${colour} ${style} ${width}`}>
        <p className="">{status}</p>
      </div>
    )
  }

  if (part.listingProcessing) {
    colour = "bg-purple-200 text-purple-500";
    status = "Listing In Progress";
  }

  if (offer.publishedOn && !part.soldDate) {
    colour = "bg-yellow-200 text-yellow-500";
    status = "Published";
  }

  //It's only active if the listing has been published and and the start date is before now
  if (offer.publishedOn && offer.listingStarted && new Date(offer.listingStarted) < new Date() && !part.soldDate) {
    colour = "bg-blue-200 text-blue-500";
    status = "Active";
  }

  if (offer.listingEnded && new Date(offer.listingEnded) < new Date() && !part.soldDate) {
    colour = "bg-red-200 text-red-500";
    status = "Ended - Not Sold";
  }

  return (
    <div className={`${colour} ${style} ${width}`}>
      <p className="">{status}</p>
    </div>
  )
}

export default ListingStatus;
